(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.header = document.querySelector('.section-header');
    this.headerBounds = {};

    this.currentScrollTop = 0;
    this.preventReveal = false;
    this.predictiveSearch = this.querySelector('predictive-search');

    if (!this.header || !(this.header instanceof Element)) {
      console.warn('[StickyHeader] Header element not found. Sticky header disabled.');
      return;
    }

    this.onScrollHandler = this.onScroll.bind(this);
    this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

    this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
    window.addEventListener('scroll', this.onScrollHandler, false);

    this.createObserver();
  }

  disconnectedCallback() {
    if (this.onScrollHandler) {
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    if (this.hideHeaderOnScrollUp) {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
    }
  }

  createObserver() {
    if (!this.header || !(this.header instanceof Element)) {
      console.warn('[StickyHeader] Cannot observe header because header element is missing.');
      return;
    }

    const observer = new IntersectionObserver((entries, observerInstance) => {
      this.headerBounds = entries[0].intersectionRect;
      observerInstance.disconnect();
    });

    observer.observe(this.header);
  }

  onScroll() {
    if (!this.header || !(this.header instanceof Element)) return;

    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

    if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

    if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
      this.header.classList.add('scrolled-past-header');

      if (this.preventHide) return;

      requestAnimationFrame(this.hide.bind(this));
    } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
      this.header.classList.add('scrolled-past-header');

      if (!this.preventReveal) {
        requestAnimationFrame(this.reveal.bind(this));
      } else {
        window.clearTimeout(this.isScrolling);

        this.isScrolling = setTimeout(() => {
          this.preventReveal = false;
        }, 66);

        requestAnimationFrame(this.hide.bind(this));
      }
    } else if (scrollTop <= this.headerBounds.top) {
      this.header.classList.remove('scrolled-past-header');
      requestAnimationFrame(this.reset.bind(this));
    }

    this.currentScrollTop = scrollTop;
  }

  hide() {
    if (!this.header || !(this.header instanceof Element)) return;

    this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
    this.closeMenuDisclosure();
    this.closeSearchModal();
  }

  reveal() {
    if (!this.header || !(this.header instanceof Element)) return;

    this.header.classList.add('shopify-section-header-sticky', 'animate');
    this.header.classList.remove('shopify-section-header-hidden');
  }

  reset() {
    if (!this.header || !(this.header instanceof Element)) return;

    this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
  }

  closeMenuDisclosure() {
    if (this.disclosures) {
      this.disclosures.forEach((disclosure) => disclosure.close());
    }
  }

  closeSearchModal() {
    if (this.searchModal) {
      this.searchModal.close(false);
    }
  }
}

if (!customElements.get('sticky-header')) {
  customElements.define('sticky-header', StickyHeader);
}

  } catch(e) { console.error(e); }
})();
})();
